import { render, staticRenderFns } from "./VoucherReceiptRoyalTower.vue?vue&type=template&id=3b02808b&"
import script from "./VoucherReceiptRoyalTower.vue?vue&type=script&lang=js&"
export * from "./VoucherReceiptRoyalTower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports